import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '../common'
import { useAuthStore } from '../../store'

interface RegisterFormProps {
  onSuccess?: () => void
}

/**
 * Form di registrazione
 */
export default function RegisterForm({ onSuccess }: RegisterFormProps) {
  const { register, loading, error, clearError } = useAuthStore()
  const [nome, setNome] = useState('')
  const [cognome, setCognome] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confermaPassword, setConfermaPassword] = useState('')
  const [localError, setLocalError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    clearError()
    setLocalError('')

    // Validazione password
    if (password !== confermaPassword) {
      setLocalError('Le password non coincidono')
      return
    }

    if (password.length < 8) {
      setLocalError('La password deve essere di almeno 8 caratteri')
      return
    }

    try {
      await register({ email, password, nome, cognome: cognome || undefined })
      onSuccess?.()
    } catch {
      // Errore gestito dallo store
    }
  }

  const displayError = localError || error

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      {/* Errore */}
      {displayError && (
        <div className="bg-red-500/10 border border-red-500/50 text-red-400 px-4 py-3 rounded-lg text-sm">
          {displayError}
        </div>
      )}

      {/* Nome e Cognome */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label htmlFor="nome" className="block text-sm font-medium text-gray-300 mb-2">
            Nome *
          </label>
          <input
            type="text"
            id="nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            className="w-full px-4 py-3 bg-night-light border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-gold transition-colors"
            placeholder="Mario"
            required
          />
        </div>
        <div>
          <label htmlFor="cognome" className="block text-sm font-medium text-gray-300 mb-2">
            Cognome
          </label>
          <input
            type="text"
            id="cognome"
            value={cognome}
            onChange={(e) => setCognome(e.target.value)}
            className="w-full px-4 py-3 bg-night-light border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-gold transition-colors"
            placeholder="Rossi"
          />
        </div>
      </div>

      {/* Email */}
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">
          Email *
        </label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-4 py-3 bg-night-light border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-gold transition-colors"
          placeholder="tu@esempio.it"
          required
        />
      </div>

      {/* Password */}
      <div>
        <label htmlFor="password" className="block text-sm font-medium text-gray-300 mb-2">
          Password *
        </label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-4 py-3 bg-night-light border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-gold transition-colors"
          placeholder="Minimo 8 caratteri"
          required
          minLength={8}
        />
      </div>

      {/* Conferma Password */}
      <div>
        <label htmlFor="confermaPassword" className="block text-sm font-medium text-gray-300 mb-2">
          Conferma Password *
        </label>
        <input
          type="password"
          id="confermaPassword"
          value={confermaPassword}
          onChange={(e) => setConfermaPassword(e.target.value)}
          className="w-full px-4 py-3 bg-night-light border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-gold transition-colors"
          placeholder="Ripeti la password"
          required
        />
      </div>

      {/* Submit */}
      <Button
        type="submit"
        variant="primary"
        className="w-full"
        disabled={loading}
      >
        {loading ? 'Registrazione in corso...' : 'Registrati'}
      </Button>

      {/* Link login */}
      <p className="text-center text-gray-400 text-sm">
        Hai già un account?{' '}
        <Link to="/login" className="text-gold hover:underline">
          Accedi
        </Link>
      </p>
    </form>
  )
}
